import { coreClient } from './coreclient'

export interface EditableOperatingStatementData {
  name: string
  as_of_date: Date
  line_items: Record<string, unknown>
}

async function parseOperatingStatement(file: File, type: 'pdf' | 'excel' | 'csv') {
  const client = await coreClient()
  return await client.operatingStatement.parse(type, { file })
}

async function index() {
  const client = await coreClient()
  return await client.operatingStatement.index()
}

async function create(body: EditableOperatingStatementData) {
  const client = await coreClient()

  // Convert Date to string for API
  const apiBody = {
    ...body,
    as_of_date: body.as_of_date ? body.as_of_date.toISOString() : body.as_of_date
  }

  return await client.operatingStatement.create(apiBody)
}

async function show(operatingStatementId: number) {
  const client = await coreClient()
  return await client.operatingStatement.show(operatingStatementId)
}

async function update(operatingStatementId: number, body: EditableOperatingStatementData) {
  const client = await coreClient()

  // Convert Date to string for API
  const apiBody = {
    ...body,
    as_of_date: body.as_of_date ? body.as_of_date.toISOString() : body.as_of_date
  }

  return await client.operatingStatement.update(operatingStatementId, apiBody)
}

async function destroy(operatingStatementId: number) {
  const client = await coreClient()
  return await client.operatingStatement.destroy(operatingStatementId)
}

export default {
  parseOperatingStatement,
  index,
  create,
  show,
  update,
  destroy
}
